import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FcpButtonModule, FcpModalModule } from 'fc-ui-components';

import { ModalModule } from '../modal.module';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { SharedModule } from 'shared/shared.module';
import { DirectivesModule } from 'app/directives/directives.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ModalModule,
        FcpButtonModule,
        FcpModalModule,
        DirectivesModule,
        ReactiveFormsModule,
        SharedModule
    ],
    declarations: [ConfirmDialogComponent],
    exports: [ConfirmDialogComponent]
})
export class ConfirmDialogModule {}
